import React from 'react';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';

import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { DataRoleSubspaceName } from '~src/spacesPlatform/state/SpaceInfo';

import { RouterError } from '../../app/spaces/RouterHelpers/RouterError';
import { FeatureFlags } from '../../ts/FeatureFlags';
import { DataRoleSpaceProvider, DataRoleSpaceProviderProps } from './DataRoleSpaceProvider';

export interface SpaceRouteParams {
  readonly id: string;
}
export interface DataRoleRouteComponentProps extends RouteComponentProps<SpaceRouteParams> {}

export interface DataRoleSpaceRouterProps {
  readonly siteName: string;
  readonly urls: SpacesSiteUrls;
}

export class DataRoleSpaceRouter extends React.Component<DataRoleSpaceRouterProps> {
  public render() {
    return (
      <Switch>
        <Route exact path={this.props.urls.dataRoleDefinitionPath(':id')} render={this.provider('definition')} />
        { FeatureFlags.semanticsServiceDataRoleConnectionsEnabled &&
          <Route exact path={this.props.urls.dataRoleConnectedDatasourcesPath(':id')} render={this.provider('connectedDatasources')} />
        }
        <Route exact path={this.props.urls.dataRolePath(':id')} render={({match}) => (
          <Redirect to={this.props.urls.dataRoleDefinitionPath(match.params.id)} />
        )} />
        <Route render={this.error} />
      </Switch>
    );
  }

  private provider = (subspaceName: DataRoleSubspaceName): (props: DataRoleRouteComponentProps) => JSX.Element => {
    return (props: DataRoleRouteComponentProps): JSX.Element => {
      const dataRoleSpaceProviderProps: DataRoleSpaceProviderProps = {
        siteName: this.props.siteName,
        subspaceName,
        dataRoleId: props.match.params.id,
        routeLocationSearch: props.location.search,
        routeLocationPath: props.location.pathname,
        urls: this.props.urls,
      };

      return <DataRoleSpaceProvider {...dataRoleSpaceProviderProps} />;
    };
  }

  private error = (): JSX.Element => {
    return <RouterError errorType={'default'} urls={this.props.urls}/>;
  }
}
